<template>
  <!-- v-show="dialogVisible" -->
  <export-plant-dialog class="exportPlantNew" :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }"
    :visible.sync="dialogVisible" :width="'auto'" :title="$t('report.Export_report')" noFooter>
    <div slot="content" class="grid" style="padding:0px;">

      <!-- {{params}} -->

      <span class="label">
        {{ $t('report.Report_type') }}
      </span>
      <el-radio-group v-model="activeType" v-removeAriaHidden>
        <el-radio label="day">{{ $t('report.Daily_report') }}</el-radio>
        <el-radio label="month">{{ $t('report.Monthly_report') }}</el-radio>
        <el-radio label="year">{{ $t('report.Yearly_Report') }}</el-radio>
        <el-radio label="total">{{ $t('report.Total_report') }}</el-radio>
        <el-radio label="range">{{ $t('report.customize') }}</el-radio>
      </el-radio-group>
      <span v-show="activeType != 'total'" class="label">
        {{ $t('report.Report_date') }}
      </span>
      <!-- 增加今日的快捷选择 -->
      <!-- :clearable="true" -->
      <el-date-picker :editable='false' ref="dayHide" :clearable="false" v-model="datevalue" v-show="activeType === 'day'"
        type="date" :placeholder="$t('report.select_date')" popper-class="select-date" :picker-options="pickerDayOptions"
        @blur="handleClickShow()">
      </el-date-picker>
      <!-- 增加今月的快捷选择 -->
      <el-date-picker :editable='false' :clearable="false" v-model="datevalue" v-show="activeType === 'month'"
        ref="datePickerMonth" type="month" :placeholder="$t('report.select_date')" popper-class="select-date"
        :picker-options="pickerMonthOptions">
      </el-date-picker>
      <!-- 增加今年的快捷选择 -->
      <el-date-picker :editable='false' :clearable="false" v-model="datevalue" v-show="activeType === 'year'" type="year"
        ref="datePickerYear" :placeholder="$t('report.select_date')" popper-class="select-date"
        :picker-options="pickerYearOptions">
      </el-date-picker>
      <el-date-picker :editable='false' :clearable="false" v-model="datevalue" v-show="activeType === 'range'"
        type="daterange" align="left" unlink-panels ref="datePickerRange" :range-separator="$t('report.to')"
        :picker-options="pickerrangeOptions" :start-placeholder="$t('report.start_date')" :end-placeholder="$t('report.End_date')" :placeholder="$t('report.select_date')"
        style="width:100%;positon:relative;" :default-value="new Date().setMonth(new Date().getMonth() - 1)" popper-class="select-date1">
      </el-date-picker>
      <span></span>
      <div style="width:100%;text-align:right;">
        <!-- 自定义报表导出时间范围提示 -->
        <!-- <span v-show="activeType=='range'" class="label" style="color:#F56C6C;">
                  {{$t('report.Report_date1')}}
        </span> -->
        <button class="btn btn-dark" @click="exportPlant">{{ $t('report.Export') }}</button>
      </div>
    </div>
    <div slot="footer">
      <!-- <button
        class="button-hollow"
        @click="closeDialog"
      >{{$t('report.cancel')}}</button> -->
      <!-- <button
        class="button-solid"
        @click="exportPlant"
      >{{$t('report.Export')}}</button> -->
    </div>
  </export-plant-dialog>
</template>
<script>
import exportPlantDialog from "@/components/dialognew/index";
import encryption from "@/assets/js/encryption";
// import qs from 'qs';
import request from "@/assets/js/request";
import config from '@/assets/js/config';
import cookie from '@/assets/js/cookie';
import { i18n } from '@/i18n';
export default {
  components: {
    exportPlantDialog
  },
  state: {
    token: null,
  },
  props: {
    params: {
      default: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.closeDialog();
        this.$refs.dayHide.handleClose()
        this.$refs.datePickerMonth.handleClose()
        this.$refs.datePickerYear.handleClose()
        this.$refs.datePickerRange.handleClose()
        document.removeEventListener('click', this.handleDocumentClick, true);
      }else{
        document.addEventListener('click', this.handleDocumentClick, true);
      }
    },
    params (val) {
      this.dialogVisible = !!val;
    },
    activeType (val) {
      this.$refs.dayHide.handleClose()
      this.$refs.datePickerMonth.handleClose()
      this.$refs.datePickerYear.handleClose()
      this.$refs.datePickerRange.handleClose()
      if (val) {
        if (val == 'day') {
          this.datevalue = new Date();
        }
      }
    },
  },
  data () {
    return {
      dialogVisible: false,
      radio: "1",
      datevalue: new Date(),
      monthlyvalue: "",
      yearvalue: "",
      totalvalue: "",
      customizevalue: "",
      activetime: "daily",
      activeType: "day",
      // 增加今日的快捷选择
      // i18n.t('device.cur_year')、cur_month、cur_day
      pickerDayOptions: {
        shortcuts: [{
          // text: `今天：
          //   ${String(new Date().getFullYear())}${i18n.t('device.year')}
          //   ${String(new Date().getMonth())}${i18n.t('device.month')}
          //   ${String(new Date().getDate())}${i18n.t('device.day')}
          // `,
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      // 增加本月的快捷选择
      pickerMonthOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_thismonth') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1)
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      // 增加年的快捷选择
      pickerYearOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_thisyear') + "：" +
            String(new Date().getFullYear())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate (time) {
          return time.getTime() >= new Date();
        }
      },
      //自定义日期选择限定31天
      startDate: '',
      pickerrangeOptions: {
        //时间范围选择控制
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate && minDate.getTime()
          if (maxDate) {
            // 选中后一个时，要把第一个的赋值清空
            this.startDate = ''
          }
        },
        disabledDate: time => {
          // 选中第一个后，后一个前后31天可选，超出的不可选，超出当前天也不可选，这里的天数按需求设定
          const minTime = new Date(this.startDate).setDate(
            new Date(this.startDate).getDate() - 30
          )
          const maxTime = new Date(this.startDate).setDate(
            new Date(this.startDate).getDate() + 30
          )
          return (
            time.getTime() > Date.now() ||
            (this.startDate
              ? time.getTime() < minTime || time.getTime() > maxTime
              : false)
          )
        },
      },
    };
  },
  methods: {
    handleDocumentClick(event) {
      if (!this.$refs.dayHide.$el.contains(event.target)&&this.activeType =='day'&&event.target.closest('.select-date') == null) {
        // 手动关闭日期选择器和对话框
        this.$refs.dayHide.handleClose()
      }else if(!this.$refs.datePickerMonth.$el.contains(event.target)&&this.activeType =='month'&&event.target.closest('.select-date') == null){
        this.$refs.datePickerMonth.handleClose()
      }else if(!this.$refs.datePickerYear.$el.contains(event.target)&&this.activeType =='year'&&event.target.closest('.select-date') == null){
        this.$refs.datePickerYear.handleClose()
      }else if(!this.$refs.datePickerRange.$el.contains(event.target)&&this.activeType =='range'&&event.target.closest('.select-date1') == null){
        this.$refs.datePickerRange.handleClose()
      }
    },
    handleClickShow () {
      this.$refs.dayHide.blur()
    },
    // 关闭弹窗
    closeDialog () {
      this.$emit("update:params", null);
    },
    //导出报表
    exportPlant () {
      if(this.activeType=='range'&&this.datevalue.length!=2){
        return false
      }
      // 导出单个报表
      if (this.params !== 'all') {

        var PNAll = [];
        var snAll = [];
        var devcodeAll = [];
        var devaddrAll = [];

        this.params.forEach(item => {
          PNAll.push(item.pn)
          snAll.push(item.sn)
          devcodeAll.push(item.devcode)
          devaddrAll.push(item.devaddr)

        });
        this.pnbox = PNAll;
        let action, param = {
          action: 'exportCollectorsData',
          i18n: this.$lang.currentLang,
          // pns: this.params.pn,
          pns: this.pnbox.join(','),
        }

        switch (this.activeType) {
          // 日报表
          case 'day':
          default:
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth() + 1,
              day: this.datevalue.getDate(),
            }
            break;
          // 月报表
          case 'month':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth() + 1,
            }
            break;
          // 年报表
          case 'year':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
            }
            break;
          // 总报表
          case 'total':
            break;
          // 区间报表
          case 'range':
            param = {
              action: 'exportDeviceRangeReport',
              source: 1,
              // plantid: this.params[0].pid,
              i18n: this.$lang.currentLang,
              sdate: this.$filter.formatDate(this.datevalue[0]),
              edate: this.$filter.formatDate(this.datevalue[1]),
              pn: PNAll.join(','),
              sn: snAll.join(','),
              devcode: devcodeAll.join(','),
              devaddr: devaddrAll.join(','),

            }
            break;
        }
        // 重复已注释
        this.$message.success(this.$t("report.download"));
        this.$request.get(action, param)
          .then((res) => {
            // 演示账号
            if (res.err) {
              this.$message.error(this.$t(`errCode.${res.err}`));
              return;
            } else {
              // ......................
              // window.location.href = “下载url”,浏览器会发起请求，下载下来
              window.location.href = this.$request.http_download_url_new(param)
              this.closeDialog();
              // ......................
            }
            // this.$message.success(this.$t("report.download"));
          }).then(() => {
            // this.$message.success(this.$t("report.download"));
          }).catch((err) => {
            this.$message.error(err);
          });
      }
      // 导出所有报表 
      else {
        let action, param = {
          action: 'exportCollectorsData',
          i18n: this.$lang.currentLang,
        } // 生成报表所需参数
        switch (this.activeType) {
          // 日报表
          case 'day':
          default:
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth() + 1,
              day: this.datevalue.getDate(),
            }
            break;
          // 月报表
          case 'month':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
              month: this.datevalue.getMonth() + 1,
            }
            break;
          // 年报表
          case 'year':
            param = {
              ...param,
              year: this.datevalue.getFullYear(),
            }
            break;
          // 总报表
          case 'total':
            break;
          // 区间报表
          // case 'range':
          //   action = 'exportCollectorsData'
          //   param = {
          //     ...param,
          //     sdate: util.formatDate(this.datevalue[0]),
          //     edate: util.formatDate(this.datevalue[1])
          //   }
          //   break;
        }
        this.$message.success(this.$t("report.download"));
        this.$request.get(action, param)
          .then(() => {
            window.location.href = this.$request.http_download_url_new(param)
            this.closeDialog();
          }).then(() => {
            this.$message.success(this.$t("report.download"));
          }).catch((err) => {
            this.$message.error(err);
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.exportPlantNew {
  .label {
    font-size: 14px;
    color: rgb(242, 242, 242);
    margin-right: 20px;
  }

  .el-input__icon {
    line-height: 32px
  }

  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-separator {
    color: #fff;
  }

  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: rgb(51, 255, 182);
    background: @primaryTextColor;
  }

  /deep/.el-radio__input.is-checked+.el-radio__label {
    color: rgb(242, 242, 242);
  }

  /deep/.el-radio {
    color: rgb(242, 242, 242);
  }

  /deep/.el-date-editor .el-input__icon {
    color: rgb(56, 165, 118);
  }

  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 7px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
}
</style>
<style lang="less">
// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}

.select-date1.el-picker-panel {
  background-color: #222D35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222D35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  
  .in-range {
    background-color: #222D35;
  }
  
  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }
  
  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }
  
  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }
  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }
  
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.in-range {
    background-color: #222D35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff
  }
}

.el-date-table td.disabled div {
  background-color: #222D35 !important;
  color: #606266 !important;
}
.el-year-table td.disabled .cell{
  background-color: #222D35 !important;
}
.el-month-table td.disabled .cell{
  background-color: #222D35 !important;
}
</style>
